import Agent from "@/pages/administrer/configuration/agents/Agent.vue";
import CreateAgent from "@/pages/administrer/configuration/agents/CreateAgent.vue";
import ShowAgent from "@/pages/administrer/configuration/agents/ShowAgent.vue";
export default [
    {
        path: 'agents',
        meta: { permissions: ["view_agent_in_charge"] },
        name: "AdminConfigAgent",
        component: Agent
    },
    {
        path: 'agents/create',
        meta: { permissions: ["create_agent_in_charge"] },
        name: "AdminConfigCreateAgent",
        component: CreateAgent
    },
    {
        path: 'agents/:id/show',
        meta: { permissions: ["view_any_agent_in_charge"] },
        name: "AdminConfigShowAgent",
        component: ShowAgent
    }]